// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KztxgrezZCpkf_ {
  flex: 1 0;
  padding: var(--ds-space-025, 2px) var(--ds-space-100, 8px);
  border: 1px solid transparent;
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-neutral, #091e420f);
}
.KztxgrezZCpkf_ span {
  display: block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.KztxgrezZCpkf_:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.WrZ5cAFtMO2FKt {
  border: 1px solid var(--ds-border-selected, #0c66e4);
  background-color: var(--ds-background-selected, #e9f2ff);
  color: var(--ds-text-selected, #0c66e4);
}
.WrZ5cAFtMO2FKt:hover {
  background-color: var(--ds-background-selected-hovered, #cce0ff);
}
.wDXDbEQTUETrLm {
  margin-right: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var button = `KztxgrezZCpkf_`;
export var selected = `WrZ5cAFtMO2FKt`;
export var lockIcon = `wDXDbEQTUETrLm`;
export default ___CSS_LOADER_EXPORT___;
